import { HorizontalScrollView } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";
import { useEffect, useRef } from "react";

interface InterviewDateSelectorProps {
  promotedDate: string | undefined;
  availableDates: string[];
  selectedDate: string | undefined;
  shouldDisableDate: (date: string) => boolean;
  onDateChange: (date: string) => void;
}

export function InterviewDateSelector(props: InterviewDateSelectorProps) {
  const { promotedDate, availableDates, selectedDate, shouldDisableDate, onDateChange } = props;

  const enabledDates = availableDates.filter((date) => !shouldDisableDate(date));
  const selectedItemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectedItemRef.current) {
      selectedItemRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [selectedDate]);

  return (
    <Stack spacing={2}>
      <HorizontalScrollView>
        {enabledDates.map((date) => {
          const isSelected = Boolean(selectedDate && date === selectedDate);

          return (
            <SelectableBox
              key={date}
              variant="secondary"
              isSelected={isSelected}
              sx={{
                ...(isDefined(promotedDate) &&
                  promotedDate === date && {
                    background: `linear-gradient(90.67deg, #FAECDE 5.65%, #D7D4FF 94.45%)`,
                  }),

                minWidth: (() => {
                  switch (enabledDates.length) {
                    case 1: {
                      return "100%"; // take full width
                    }

                    case 2: {
                      return "calc(50% - 4px)"; // take half width each
                    }

                    default: {
                      return "calc(40% - 4px)"; // show 2.5 dates
                    }
                  }
                })(),
              }}
              onToggleSelect={() => {
                onDateChange(date);
              }}
            >
              <Box key={date} ref={isSelected ? selectedItemRef : undefined}>
                {date}
              </Box>
            </SelectableBox>
          );
        })}
      </HorizontalScrollView>
    </Stack>
  );
}
